import React, { Component } from 'react';

import Navigation from './Navigation.js';
import Footer from './Footer.js';

class Contact extends Component {
    componentDidMount() {
        window.initMailer();
    }

    render() {
        return (
            <div>
                <Navigation />
                <header className="header pt-9 pb-2">

                    <div className="container">

                        <form className="row gap-y" action="sendmail2.php" method="POST" data-form="mailer">
                            <div className="col-lg-7">
                                <h3>Contact</h3>
                                <br />
                                <div id="error"></div>
                                <div className="alert alert-success d-on-success">Nous avons reçu votre message et nous vous recontacterons très vite.</div>
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <input className="form-control form-control-lg" type="text" name="name" placeholder="Votre nom" autocomplete="off" required />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <input className="form-control form-control-lg" type="email" name="email" placeholder="Votre adresse e-mail" autocomplete="off" required />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <textarea className="form-control form-control-lg" rows="4" placeholder="Votre message" name="message" autocomplete="off" required></textarea>
                                </div>

                                <button className="btn btn-lg btn-warning" type="submit">Envoyer votre message</button>
                            </div>
                            <div className="col-lg-4 ml-auto text-center text-lg-left">
                                <hr className="d-lg-none" />
                                <div className="bg-gray h-full p-5">
                                    <h3>Note</h3>
                                    <p>Pour toute demande ou information, n'hésitez pas à me laisser un message.  <br /> <br />Pour me contacter, envoyez un mail à l'adresse <a href="mailto:helene.arfi@gmail.com"><span className="text-warning fw-600">helene.arfi@gmail.com</span></a> ou utilisez le formulaire.</p>

                                    <div className="fw-400 text-dark">Vous pouvez me suivre sur ma page Instagram <br /><br /></div>
                                    <a href="https://www.instagram.com/helene.arfi/" className="btn btn-label btn-warning btn-block" target="_blank">
                                        <label><i className="fa fa-instagram"></i></label> Instagram
                                        </a>
                                </div>

                            </div>
                        </form>

                    </div>


                </header>
                {/* <Footer /> */}
            </div>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact.js